import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'
import { style } from './avatar-group.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'


@customElement('cse-avatar-group')
export class CSEAvatarGroup extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, style]

  override render() {
    return html`
    <div class="cse-avatar-group">
      <slot></slot>
    </div>`
  }
}
